/** Individual vs business scope for client detail sections. */
export const CLIENT_DETAIL_CATEGORIES = ["individual", "business"];

export function normalizeClientDetailCategory(value) {
  const raw = String(value ?? "")
    .trim()
    .toLowerCase();
  if (raw === "business" || raw.startsWith("business")) return "business";
  return "individual";
}

export function messageStoreKey(clientId, category) {
  return `${String(clientId)}:${normalizeClientDetailCategory(category)}`;
}

/** Records without category are treated as individual. */
export function recordMatchesClientCategory(record, category) {
  const cat = normalizeClientDetailCategory(category);
  const raw =
    record?.category ??
    record?.document_category ??
    record?.comment_category ??
    record?.message_category ??
    record?.requested_file_category ??
    record?.invoice_category ??
    record?.strategy_category ??
    record?.service_category;
  if (raw == null || String(raw).trim() === "") {
    return cat === "individual";
  }
  return normalizeClientDetailCategory(raw) === cat;
}

export function filterRecordsByClientCategory(records, category) {
  if (!category) return records || [];
  return (records || []).filter((record) =>
    recordMatchesClientCategory(record, category),
  );
}

export function resolveTabsFromNavigationState(state = {}) {
  const tab = String(state?.tab || "").trim();
  const documentCategory = normalizeClientDetailCategory(
    state?.documentCategory ??
      state?.document_category ??
      state?.category ??
      state?.service_category ??
      state?.serviceCategory,
  );

  let categoryTab = documentCategory;
  let activeTab = "profile";

  const tabMap = {
    personal: { category: "individual", tab: "profile" },
    business: { category: "business", tab: "profile" },
    profile: { tab: "profile" },
    individualDocuments: { category: "individual", tab: "documents" },
    businessDocuments: { category: "business", tab: "documents" },
    documents: { tab: "documents" },
    invoices: { tab: "invoices" },
    comments: { tab: "comments" },
    messages: { tab: "messages" },
    notification: { tab: "notification" },
    taxStrategy: { tab: "taxStrategy" },
    services: { tab: "services" },
    "e-filing": { tab: "e-filing" },
  };

  if (tabMap[tab]) {
    if (tabMap[tab].category) categoryTab = tabMap[tab].category;
    activeTab = tabMap[tab].tab;
  } else if (tab) {
    activeTab = tab;
  }

  // Explicit category from navigation wins over tab-map defaults
  // (e.g. Pending Services → Services should open Individual or Business).
  if (
    state?.documentCategory != null ||
    state?.document_category != null ||
    state?.category != null ||
    state?.service_category != null ||
    state?.serviceCategory != null
  ) {
    categoryTab = documentCategory;
  }

  return { categoryTab, activeTab };
}

export function getStaffClientSubTabs(categoryTab) {
  const isBusiness = normalizeClientDetailCategory(categoryTab) === "business";
  return [
    {
      id: "profile",
      label: isBusiness ? "Business Details" : "Personal Details",
    },
    {
      id: "services",
      label: isBusiness ? "Business Services" : "Individual Services",
    },
    {
      id: "documents",
      label: isBusiness ? "Business Documents" : "Individual Documents",
    },
    { id: "messages", label: "Messages" },
    { id: "invoices", label: "Invoices" },
    { id: "taxStrategy", label: "Tax Planning" },

    { id: "comments", label: "Notes" },
    { id: "e-filing", label: "E-filing" },
    { id: "notification", label: "Notification" },
  ];
}

export const STAFF_CLIENT_SUB_TABS = getStaffClientSubTabs("individual");

export const CLIENT_SELF_SUB_TABS = [
  { id: "messages", label: "Messages" },
  { id: "taxStrategy", label: "Tax Planning" },
];
